import { mapPiiTrainingStatus } from '@/services/piiTraining/piiTraining.mappers';
import { gateStatusQueryOptions } from '@/services/statusGate/useStatusGate';
import type { PiiTrainingStatus, PiiTrainingStatusResponse } from '@/types/piiTraining';

/** Scoped per auth account so a cached status never leaks across users (e.g. impersonation). */
export const piiTrainingStatusQueryKey = (accountId: string | null) => ['pii-training-status', accountId] as const;

export const fetchPiiTrainingStatus = async (): Promise<PiiTrainingStatus> => {
  const response = await fetch('/api/pii-training/status', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error('Failed to check PII training status');
  const body: PiiTrainingStatusResponse = await response.json();
  return mapPiiTrainingStatus(body);
};

/** Shared by the guard and the post-submit verification. */
export const piiTrainingStatusQueryOptions = (accountId: string | null) =>
  gateStatusQueryOptions(piiTrainingStatusQueryKey(accountId), fetchPiiTrainingStatus);
